export default __webpack_public_path__ + "static/media/youtube-black.4b85e0f3.png";